import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { PROFILES } from "../lib/profiles";
import { FadeUp, Overline } from "./Motion";

const SPANS = [
  "lg:col-span-7 lg:row-span-1 min-h-[420px] lg:min-h-[480px]",
  "lg:col-span-5 lg:row-span-1 min-h-[420px] lg:min-h-[480px]",
  "lg:col-span-5 lg:row-span-1 min-h-[380px] lg:min-h-[400px]",
  "lg:col-span-7 lg:row-span-1 min-h-[380px] lg:min-h-[400px]",
];

const Card = ({ p, i }) => (
  <FadeUp delay={i * 0.08} className={`col-span-1 ${SPANS[i]}`}>
    <Link to={`/perfil/${p.slug}`} data-testid={`profile-card-${p.slug}`} className="group relative flex h-full min-h-[inherit] flex-col justify-end overflow-hidden border border-[#D4AF37]/20 bg-[#111D3A]">
      <motion.img src={p.image} alt={p.title} loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-70 transition-[transform,opacity] duration-1000 ease-out group-hover:scale-[1.06] group-hover:opacity-90" />
      <span className="absolute inset-0 bg-gradient-to-t from-[#0B132B] via-[#0B132B]/70 to-[#0B132B]/10" />
      <span className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700 bg-[radial-gradient(600px_circle_at_30%_100%,rgba(212,175,55,0.22),transparent_60%)]" />
      <span className="absolute top-6 left-6 right-6 flex items-center justify-between">
        <span className="font-mono text-xs text-[#E6C687]">{p.index} / 04</span>
        <span className="flex h-11 w-11 items-center justify-center rounded-full border border-[#D4AF37]/40 text-[#E6C687] transition-[background-color,color,transform] duration-500 group-hover:bg-[#D4AF37] group-hover:text-[#0B132B] group-hover:rotate-45">
          <ArrowUpRight className="w-5 h-5" />
        </span>
      </span>
      <span className="relative p-6 md:p-8">
        <span className="block text-[11px] uppercase tracking-[0.28em] text-[#D4AF37]">{p.kicker}</span>
        <span className="mt-3 block font-display text-3xl md:text-4xl text-white leading-[1.05]">{p.title}</span>
        <span className="mt-4 block max-w-md text-sm md:text-base text-[#C0C9DC] leading-relaxed">{p.short}</span>
        <span className="mt-6 inline-flex items-center gap-2 text-sm text-[#E6C687] border-b border-[#D4AF37]/40 pb-1">Ver página dedicada</span>
      </span>
    </Link>
  </FadeUp>
);

export const ProfileBento = () => (
  <section id="perfis" data-testid="profiles-section" className="relative mx-auto max-w-[1360px] px-6 lg:px-10 py-24 md:py-36">
    <div className="grid gap-8 lg:grid-cols-12 items-end mb-14 md:mb-20">
      <FadeUp className="lg:col-span-7">
        <Overline>Escolha a sua situação</Overline>
        <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.02]">Cada caso tem <em className="text-gold-gradient not-italic font-display italic">uma estratégia</em> própria.</h2>
      </FadeUp>
      <FadeUp delay={0.1} className="lg:col-span-5">
        <p className="text-base md:text-lg text-[#C0C9DC] leading-relaxed">Do motorista com o carro em busca e apreensão ao produtor rural com máquinas, execuções e monitórias. Encontre a página feita para o seu momento.</p>
      </FadeUp>
    </div>
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 md:gap-5">
      {PROFILES.map((p, i) => <Card key={p.slug} p={p} i={i} />)}
    </div>
  </section>
);
